import { formatDisplayCurrency } from "@/lib/currencyHelpers";

export type ChartTooltipItem = {
  name: string;
  value: number | string;
  color: string;
};

export type ChartTooltipProps = {
  active?: boolean;
  title?: string;
  subtitle?: string;
  items: ChartTooltipItem[];
  formatAsCurrency?: boolean;
};

const ChartTooltip = ({ active = false, title, subtitle, items, formatAsCurrency = false }: ChartTooltipProps) => {
  if (!active || !items.length) return null;

  const formatValue = (value: number | string) => {
    if (formatAsCurrency && typeof value === "number") {
      return `$${formatDisplayCurrency(value)}`;
    }
    return value;
  };

  return (
    <div className="bg-sys-brand-inverse-surface p-3 rounded">
      {title && <p className="text-label-large text-sys-brand-inverse-on-surface">{title}</p>}
      {subtitle && <p className="text-label-medium text-sys-brand-inverse-on-surface">{subtitle}</p>}

      <div className="mt-2">
        {items.map((item, index) => (
          <div key={index} className="flex gap-1 items-center">
            <div
              className="w-3 h-3 border border-sys-brand-inverse-on-surface"
              style={{ backgroundColor: item.color }}
            />
            <p className="text-body-small text-sys-brand-inverse-on-surface">
              {`${item.name}: ${formatValue(item.value)}`}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChartTooltip;
